enum PerformanceCodeKey {
   WorkHours = 'werkuren',
   Leave = 'verlof',
   RecoveryReductionInWorkingTime = 'recup-a-d-v',
   PublicHoliday = 'feestdag',
   UnspecifiedIllness = 'ziekte-onbepaald',
   LawfulAbsence = 'toegestaan-afwezig',
   UnlawfulAbsence = 'onwettig-afwezig',
   EuropeanLeave = 'europees-verlof',
   LeaveOfAbsence = 'klein-verlet-onbepaald',
   SicknessWithoutAttestation = 'ziekte-zonder-attest',
   StElooi = 'st-elooi',
   TemporaryUnemploymentForceMajeureMedical = 'werkloos-overmacht-medische-reden',
   UnspecifiedOccupationalAccident = 'arbeidsongeval-onbepaald',
   AdoptionLeave = 'adoptieverlof',
   ApplicationLeave = 'sollicitatieverlof',
   Break = 'pauze',
   BreastfeedingBreak = 'borstvoedingspauze/-verlof',
   BridgingHours = 'overbruggingsuren',
   C32CompanyWideClosureRecoveryLeave = 'c3.2-collectieve-sluiting-i-r',
   C32CompanyWideLeaveJV = 'c3.2-collectieve-sluiting-j-v',
   C32EconomicReason = 'c3.2-werkloos-econ.-reden',
   C32LackOfWorkDueToEconomicReasonsWhiteCollarWorker = 'c3.2-econ-werkloos-bediende',
   C32NoWorkDueToExtremeWeather = 'c3.2-werkloos-slecht-weer',
   C32NoWorkForAnotherReason = 'c3.2-werkloos-andere-reden',
   CareerLeaveFullTime = 'tijdskrediet-voltijds',
   CareerLeavePartTime = 'tijdskrediet-deeltijds',
   CollectiveLabourAgreementHours = 'c-a-o-uren',
   CompulsoryFamilyReasons = 'dwingende-familiale-reden',
   EducationalLeaveFlemishTrainingLeave = 'educatief-verlof/-v-o-v',
   FurloughForceMajeureQuarantine = 't-w-overmacht-quarantaine',
   InterruptedDay = 'onderbroken-dag',
   LateInEarlyOut = 'laat-in/-vroeg-uit',
   MaternityLeave = 'zwangerschapsverlof',
   MedicalSupportFullTime = 'medische-bijstand-voltijds',
   MedicalSupportPartTime = 'medische-bijstand-deeltijds',
   NotClocked = 'niet-geprikt',
   OccupationalAccident = 'arbeidsongeval',
   Overtime = 'overuren',
   OvertimeFullDay = 'overuren-volledige-dag',
   PaidLeaveBirthday = 'betaald-verlof-verjaardag',
   PalliativeLeaveFullTime = 'palliatief-verlof-voltijds',
   PalliativeLeavePartTime = 'palliatief-verlof-deeltijds',
   ParentalLeaveFullTime = 'ouderschapsverlof-voltijds',
   ParentalLeavePartTime = 'ouderschapsverlof-deeltijds',
   ParentalLeaveCoronaFullTime = 'ouderschapsverlof-corona-voltijds',
   ParentalLeaveCoronaPartTime = 'ouderschapsverlof-corona-deeltijds',
   ReadyToStart = 'ready2-start',
   RecoveryOther = 'recuperatie-ander',
   RecoveryOvertime = 'recup-overuren',
   RecoveryPermanence = 'recuperatie-permanentie',
   RelanceOvertime = 'relance-overuren',
   RelanceOvertimeFullDay = 'relance-overuren-volle-dag',
   SeniorHoliday = 'seniorvakantie',
   StrikeC32 = 'staking-c3.2',
   TemporaryUnemploymentForceMajeureCorona = 't-w-overmacht-corona',
   TemporaryUnemploymentForceMajeureQuarantineChildcare = 't-w-overmacht-quarant.kinderopvang',
   Training = 'training',
   TrainingMeeting = 'opleiding/-vergadering',
   TravelTime = 'reisuren',
   UnemployedForceMajeure = 'werkloos-overmacht',
   WaitingHours = 'wachturen',
   WeeklyDayOfRest = 'wekelijkse-rustdag',
   YouthHoliday = 'jeugdvakantie',
}

export { PerformanceCodeKey };
